import { createAction } from 'redux-actions';

export const moduleName = 'payment';

export const CARD_ADD_SUCCEEDED = `${moduleName}/CARD_ADD_SUCCEEDED`;
export const SUBSCRIPTION_ADD_SUCCEEDED = `${moduleName}/SUBSCRIPTION_ADD_SUCCEEDED`;

export const addCardSuccess = createAction(CARD_ADD_SUCCEEDED);
export const subscriptionAddSuccess = createAction(SUBSCRIPTION_ADD_SUCCEEDED);

